import styled, { keyframes } from 'styled-components'
import * as DialogPrimitive from '@radix-ui/react-dialog'
import { X } from 'lucide-react'

// Animations
export const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`

export const fadeOut = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`

export const scaleIn = keyframes`
  from { opacity: 0; transform: translate(-50%, -48%) scale(0.95); }
  to { opacity: 1; transform: translate(-50%, -50%) scale(1); }
`

export const scaleOut = keyframes`
  from { opacity: 1; transform: translate(-50%, -50%) scale(1); }
  to { opacity: 0; transform: translate(-50%, -48%) scale(0.95); }
`

export const StyledOverlay = styled(DialogPrimitive.Overlay)`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999999999;
  &[data-state='open'] { animation: ${fadeIn} 150ms ease-out forwards; }
  &[data-state='closed'] { animation: ${fadeOut} 150ms ease-in forwards; }
`

export const StyledContent = styled(DialogPrimitive.Content)`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000000000;
  background: #ffffff;
  border-radius: 12px;
  padding: 24px 20px;
  width: calc(100% - 2rem);
  max-width: 480px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  &[data-state='open'] { animation: ${scaleIn} 150ms ease-out forwards; }
  &[data-state='closed'] { animation: ${scaleOut} 150ms ease-in forwards; }
`

export const CloseButton = styled(DialogPrimitive.Close)`
  position: absolute;
  top: 10px;
  right: 10px;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  padding: 4px;
  border-radius: 6px;
  opacity: 0.7;
  &:hover { opacity: 1; background: rgba(0,0,0,0.06); }
  & > svg { pointer-events: none; }
`

export const DialogHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: center;
  @media (min-width: 640px) { text-align: left; }
`

export const DialogFooter = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: 8px;
  @media (min-width: 640px) { flex-direction: row; justify-content: flex-end; }
`

export const DialogTitleStyled = styled(DialogPrimitive.Title)`
  font-size: 18px;
  font-weight: 600;
  line-height: 1;
`

export const DialogDescriptionStyled = styled(DialogPrimitive.Description)`
  font-size: 14px;
  color: #5f5f5f;
`

// export X icon for CloseButton default content
export const CloseIcon = X 